<template>
  <div class="abouts kjks">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <h2 class="about_h2_t">
        <i></i>
        <span>{{ $t('original.languages161') }}</span>
      </h2>
      <el-form-item :label="$t('original.Release_theme')" prop="name">
        <el-input v-model="form.name" maxlength="100"></el-input>
      </el-form-item>

      <el-form-item :label="$t('original.Publish_type')" prop="region">
        <el-select v-model="form.region" :placeholder="$t('original.languages3')">
          <el-option :label="$t('original.languages89')" value="0"></el-option>
          <el-option label="个体发布" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('original.grade')" prop="EntryDate">
        <el-select v-model="form.EntryDate" multiple  :placeholder="$t('original.languages3')">
          <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('original.user_types')" class="nianji" prop="roleID">
        <el-select v-model="form.roleID" multiple :placeholder="$t('original.languages41')">
          <el-option v-for="item in optsssss[0].RoleList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('original.languages91')" style="height:120px" prop="StartGuidelines">
        <el-input style="height:120px" type="textarea"  v-model="form.StartGuidelines"  maxlength="2000"  show-word-limit></el-input>
      </el-form-item>

      <el-form-item :label="$t('original.languages92')" prop="FinishGuidelines">
        <el-input type="textarea" v-model="form.FinishGuidelines" maxlength="2000" show-word-limit></el-input>
      </el-form-item>

      <div class="cover">
        <span>{{ $t('original.languages93') }}</span>
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/gif,image/png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择封面</span>
          </i>
        </el-upload>
        <p>{{ $t('original.languages94') }}</p>
        <div class="cctp" @click="cctp">{{ $t('original.languages95') }}</div>
      </div>
      
      <div class="scale0">
        <span><i style="color: #f56c6c;">*</i> {{ $t('original.Release_object') }}</span>

        <ul v-if="wpc1">
          <li> {{ $t('original.Select_publish_object') }}</li>
        </ul>

        <ul v-for="item in jsonArray2" :key="item.message">
          <li>
            <span :title="item">{{ item }}</span>
            <i @click="drawerss" class="el-icon-close"></i>
          </li>
        </ul>

        <el-button @click="drawerss" plain style="margin-left: 415px; position: absolute;top:0px;left:20px;">
           {{ $t('original.Select_the_object') }}
        </el-button>
        
        <el-drawer :visible.sync="drawer0" :with-header="false">
          <div class="scale_list">
            <el-input class="scale_right_input" style="width: 50% !important;margin-left: 20px;margin-top: 30px;padding-right: 20px;" v-model="DeptName" placeholder="输入发布对象查询"></el-input>
            <el-button type="primary" @click="querydep">{{ $t('original.search') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('original.languages59') }}</el-button>
            <el-tree @check-change="check" :check-strictly="isCheck" @node-expand="nodeExpand" :data="data" show-checkbox  ref="tree" highlight-current :props="defaultProps" :default-checked-keys="murenxianshi" node-key="DeptID"></el-tree>
            <div class="confirm" style="margin-top: 40px;margin-bottom: 110px;text-align: center;"></div>
          </div>
        </el-drawer>

      </div>
      <div class="scale">
        <span><i style="color: #f56c6c;">*</i>{{ $t('original.Test_scale') }}</span>

        <ul v-if="wpc2">
          <li> {{ $t('original.Please_select_the_test_scale') }}</li>
        </ul>

        <ul v-for="item in jsonArray" :key="item.message">
          <li>
            <span :title="item.name">{{ item.name }}</span>
            <i @click="del(item.code)" class="el-icon-close"></i>
          </li>
        </ul>

        <el-form-item :label="$t('original.languages165')" style="margin-top: 20px;">
          <el-radio v-model="form.radio" :label="1"> {{ $t('original.languages162') }}</el-radio>
          <el-radio v-model="form.radio" :label="0"> {{ $t('original.languages163') }}</el-radio>
        </el-form-item>

        <el-form-item :label="$t('original.languages620')" style="margin-top: 20px;">
          <el-radio v-model="form.radioMessage" :label="1"> {{ $t('original.languages162') }}</el-radio>
          <el-radio v-model="form.radioMessage" :label="0"> {{ $t('original.languages163') }}</el-radio>
        </el-form-item>

        <el-form-item label="预警设置">
          <el-select v-model="form.conditionID" :placeholder="$t('original.languages3')">
            <el-option v-for="item in querypapercondition" :key="item.conditioncode" :label="item.conditionname" :value="item.conditioncode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发布形式" style="margin-top: 20px;">
          <el-radio v-model="form.Nation" :label="0">国际</el-radio>
          <el-radio v-model="form.Nation" :label="1">国内</el-radio>
          <el-radio v-model="form.Nation" :label="2">其他</el-radio>
        </el-form-item>
        
        <el-button @click="drawer = true" plain style="margin-left: 415px;position:absolute;top:0px;left:20px;">
           {{ $t('original.Select_scale') }}
        </el-button>

        <el-drawer class="scale_right" :visible.sync="xztcdrawer" :with-header="false">
          <div class="scale_right_div">
            <h2> {{ $t('original.Select_scale') }}</h2>
            <span> ({{ $t('original.languages100') }}<i>{{ scalenum }}</i>{{ $t('original.languages101') }}) </span>
          </div>
          
          <el-input  class="scale_right_input" style="width:60% !important;margin-left:20px;margin-top:30px;padding-right:20px;" v-model="formInline.user"  placeholder="输入量表名称搜索"></el-input>
          <el-button type="primary" @click="query">{{ $t('original.search') }}</el-button>
          <el-button type="primary" @click="confirm2">{{ $t('original.languages59') }}</el-button>
          <div class="scale_list" style="height: 100%;">
            <el-tabs :tab-position="tabPosition">
              <el-tab-pane class="cvde" style="text-align: left !important;" v-for="item in scalelist" :key="item.message" :label="item.PaperName">
                <el-checkbox-group v-model="checkboxGroup1" v-for="(item,index) in item.LiPaper" :key="index" size="small">
                  <el-checkbox @change="checkedAllFun" :label="item.PaperCode" :name="item.PaperName">{{ item.PaperName }}</el-checkbox>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-drawer>

        <el-drawer class="scale_right" :visible.sync="drawer" :with-header="false">
          <div class="scale_right_div">
            <h2> {{ $t('original.Select_scale') }}</h2>
            <span> ({{ $t('original.languages100') }}<i>{{ scalenum }}</i>{{ $t('original.languages101') }}) </span>
          </div>
          
          <el-input  class="scale_right_input" style="width:60% !important;margin-left:20px;margin-top:30px;padding-right:20px;" v-model="formInline.user"  placeholder="输入量表名称搜索"></el-input>
          <el-button type="primary" @click="query">{{ $t('original.search') }}</el-button>
          <el-button type="primary" @click="confirm2">{{ $t('original.languages59') }}</el-button>
          <div class="scale_list" style="height: 100%;">
            <el-tabs :tab-position="tabPosition">
              <el-tab-pane class="cvde" style="text-align: left !important;" v-for="item in scalelist" :key="item.message" :label="item.PaperName">
                <el-checkbox-group v-model="checkboxGroup1" v-for="(item,index) in item.LiPaper" :key="index" size="small">
                  <el-checkbox @change="checkedAllFun" :label="item.PaperCode" :name="item.PaperName">{{ item.PaperName }}</el-checkbox>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-drawer>

      </div>

      <div class="set_time">
        <h2 class="about_h2_t" style="margin-top: 20px;">
          <i></i>
          <span>{{$t('original.Set_the_time')}}</span>
        </h2>
        <span><i style="color: #f56c6c;">*</i> {{ $t('original.Valid_time') }}</span>
        <div class="block">
          <el-date-picker 
            type="date"
            :picker-options="startTimeOption"
            @change="chooseStartTime"
            value-format="yyyy-MM-dd"
            v-model="startTime"
            placeholder="开始日期"
            style="margin-right: 20px;">
          </el-date-picker>
          
          <span style="margin: 0 10px;">至</span>
          
          <el-date-picker 
            type="date"
            :picker-options="endTimeOption"
            @change="chooseEndTime"
            value-format="yyyy-MM-dd"
            v-model="endTime"
            placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>

      <el-form-item style="margin-top: 40px;margin-left: 20px;">
        <el-button type="success" :loading="todisabled" :disabled = todisabled @click="onSubmit1('form')"> {{ $t('original.save') }}</el-button>
        <el-button type="success" :loading="todisabled" :disabled = todisabled @click="onSubmit2('form')"> {{ $t('Education.languages14') }}</el-button>
        <el-button type="warning" @click="Cancels"> {{ $t('original.return') }}</el-button>
      </el-form-item>

    </el-form>

    
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">

      <span style="font-size: 99px;margin-left:40%" class="el-icon-loading"></span>
      <p style="text-align:center;margin-top:20px;padding-bottom:20px">数据正在上传，请稍等。。。</p>

    </el-dialog>


  </div>
</template>
<script>

export default {
  data() {
    return {
      startTime: '', // 单独的开始时间
      endTime: '',   // 单独的结束时间
      xztcdrawer:false,
      dialogVisible:false,
      gradedata:[],
      querypapercondition: [],
      GetUserTypelist:[],
      isCheck:false,
      todisabled: false,
      murenxianshi: [],
      Back_num: '',
      DeptName: '',
      file: '',
      drawer: false,
      drawer0: false,
      uny: false,
      scalenum: '0',
      scalelist: '',
      zonglist: [],
      checkboxGroup1: [],
      checkboxGroup222: [],
      checkboxGroup333: [],
      chec: {},
      tabPosition: 'left',
      imageUrl: '',
      radio: 1,
      value1: '',
      times: '',
      wpc1: true,
      wpc2: true,
      jsonArray: [],//测试量表显示数组
      jsonArray2: [],//发布对象显示数组
      jsonArray3: [],//发布对象提交数组
      excessive: [],//发布对象显示过度数组
      excessive2: [],//发布对象提交过度数组
      data: [],
      formInline: {user: '',},
      defaultProps: {children: 'children',label: 'label'},
      form: {
        roleID: '',
        name: '',
        region: '0',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        StartGuidelines: '',
        FinishGuidelines: '',
        radio: 1,
        conditionID: '',
        Nation:0,
        EntryDate: [],
        radioMessage:0,
      },
      optsssss:'',
      rules: {
        name:   [{ required: true, message: '请输入发布主题', trigger: 'blur' }],
        region: [{ required: true, message: '请选择发布类型', trigger: 'blur' }],
        EntryDate: [{ required: true, type: 'array', min: 1, message: '请选择年级', trigger: 'change' }],
        roleID: [{ required: true, type: 'array', min: 1, message: '请选择用户类型', trigger: 'change' }],
      },
      // 开始时间选择器选项
      startTimeOption: {
        disabledDate: (date) => {
          // 开始时间不能选择今天之前的日期
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      // 结束时间选择器选项
      endTimeOption: {
        disabledDate: (date) => {
          // 结束时间不能选择开始时间之前的日期
          const start = this.startTime ? new Date(this.startTime) : null;
          if (start) {
            return date.getTime() < start.getTime() - 24 * 60 * 60 * 1000;
          }
          // 如果没有选择开始时间，结束时间不能选择今天之前的日期
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
        },
      },
    }
  },
  beforeCreate() {
    this.$Http_Post('ScaleIssue/GetShowScale', { Tiaojian: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.scalelist = res.Data
      }
    })
    this.$Http_Post('User/GetUserType').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.optsssss = res.Data;
      }
    })
  },
  methods: {
    // 选择开始时间
    chooseStartTime(date) {
      this.startTime = date;
      // 如果结束时间早于开始时间，清空结束时间
      if (this.endTime && new Date(this.endTime) < new Date(date)) {
        this.endTime = '';
      }
    },
    // 选择结束时间
    chooseEndTime(date) {
      this.endTime = date;
    },
    // 组合时间格式，用于提交
    getTimeRange() {
      if (this.startTime && this.endTime) {
        return [this.startTime, this.endTime];
      }
      return '';
    },

    xztcfun(){
      this.xztcdrawer = true;
    },
    nodeExpand(dt, obj, node) {
      let allNodes = this.$refs.tree.getCheckedNodes();
      let _this = this;
      if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
        dt.children = [{ label: '数据加载中...' }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID:dt.DeptID,content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data;
              setTimeout(() => {
                if(obj.checked){
                  dt.children.forEach((item)=>{allNodes.push(item)})
                  this.$refs.tree.setCheckedNodes(allNodes);
                }
                let arr = _this.murenxianshi;
                this.murenxianshi = [];
                if (arr.length > 0) {
                  for (let i = 0; i < arr.length; i++) {
                    _this.murenxianshi.push(arr[i])
                  }
                }
              }, 100)
            }
          }
        })
      }
    },
    cctp() {
      this.imageUrl = '';
      this.file = '';
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.file = file
      } else {
        this.$message({type: 'error',message: '文件格式错误，请上传图片',})
      }
    },
    Cancels() {
      this.$router.push('Published');
    },
    query() {
      this.$Http_Post('ScaleIssue/GetShowScale', {Tiaojian: this.formInline.user,})
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.scalelist = res.Data
        }
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        })
      })
    },
    querydep() {
      this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',DeptName: this.DeptName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
        }
      })
    },
    drawerss(DeptName) {
      this.drawer0 = true;
    },
    del(code) {
      var slist = this.checkboxGroup1;
      var i = 0;
      for (i = 0; i < slist.length; i++) {
        if (slist[i] == code) {
          slist.splice(i, 1);
        }
      }
      var ss = this.jsonArray;
      var ii = 0;
      for (ii = 0; ii < ss.length; ii++) {
        if (ss[ii].code == code) {
          ss.splice(ii, 1);
        }
      }
      this.scalenum = this.checkboxGroup1.length;
    },
    getSimpleCheckedNodes(store) {//定义数组
      const checkedNodes = []; //判断是否为全选，若为全选状态返回被全选的节点，不为全选状态正常返回被选中的节点
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach((child) => {
          if (child.checked) {
            checkedNodes.push(child.data);
          }
          if (child.indeterminate) {
            traverse(child);
          }
        })
      }
      traverse(store)
      return checkedNodes
    },
    check(a, check,b) {//部门点击事件
      this.zonglist = this.getSimpleCheckedNodes(this.$refs.tree.store);
    },
    confirm() {//部门确定
      this.drawer0 = false;
      this.jsonArray2 = [];
      this.jsonArray3 = [];
      for (var i = 0; i < this.zonglist.length; i++) {
        this.jsonArray2.push(this.zonglist[i].label);
        this.jsonArray3.push(this.zonglist[i].DeptID);
      }
      if (this.jsonArray2.length >= 1) {
        this.wpc1 = false;
      } else {
        this.wpc1 = true;
      }
    },
    confirm2() {
      this.drawer = false;
    },
    dealwith() {
      var newArr = []
      for (var i = 0; i < this.checkboxGroup333.length; i++) {
        if (newArr.indexOf(this.checkboxGroup333[i]) === -1) {
          newArr.push(this.checkboxGroup333[i]);
        }
      }
    },
    getCheckedKeys() {

    },
    checkedAllFun(string, number, boolean) {
      if (string) {
        var uncs = {};
        uncs.name = number.target.name;
        uncs.code = number.target.value;
        this.jsonArray.push(uncs);
      } else {
        var ss = this.jsonArray;
        var i = 0;
        for (i = 0; i < ss.length; i++) {
          if (ss[i].name == number.target.name) {
            ss.splice(i, 1);
          }
        }
      }
      this.scalenum = this.checkboxGroup1.length
      if (this.jsonArray.length >= 1) {
        this.wpc2 = false;
      } else {
        this.wpc2 = true;
      }
    },
    scaleqd() {},
    onSubmit1(formName) {
      this.onSubmit(formName,'1');   //暂存
    },
    onSubmit2(formName) {
      this.onSubmit(formName,'2');  //提交
    },
    onSubmit(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证时间
          if (!this.startTime || !this.endTime) {
            this.$message.error('请选择完整的时间范围');
            return false;
          }
          
          if (new Date(this.endTime) < new Date(this.startTime)) {
            this.$message.error('结束时间不能早于开始时间');
            return false;
          }

          // 验证通过后再显示对话框
          this.dialogVisible = true;
          this.todisabled = true;
          var from = new FormData();
          from.append('Type', type);
          from.append('IsNickName', this.form.radio);
          from.append('IsMessage', this.form.radioMessage);
          from.append('EntryDate', this.form.EntryDate);
          from.append('Nation', this.form.Nation);
          from.append('roleID', this.form.roleID);
          from.append('fbCover', this.file.raw);
          from.append('fbTheme', this.form.name);
          from.append('fbModule', this.form.region);
          from.append('fbObject', this.jsonArray3);
          from.append('fbScale', this.checkboxGroup1);
          from.append('fbTime', this.getTimeRange()); // 使用组合的时间范围
          //from.append('fbTime', this.times);
          from.append('StartGuidelines', this.form.StartGuidelines);
          from.append('FinishGuidelines', this.form.FinishGuidelines);
          from.append('conditionCode', this.form.conditionID);
          from.append('token', this.$cookies.get('token'));
          this.$Http_Post('ScaleIssue/AddScale', from, {'Content-Type': 'multipart/form-data',}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.dialogVisible = false
              this.Global.request_successful(res.Message);
              this.$router.push('Published');
            } else {
              this.todisabled = false;
              this.dialogVisible = false
              this.Global.request_failure(res.Message);
            }
          }).catch((err) => {
            this.todisabled = false;
            this.dialogVisible = false;
            this.$message.error('提交失败，请重试');
          })
        } else {
          // 验证失败，不显示对话框
          this.$message.error('请填写完整的必填项');
          return false;
        }
      })
    },
    
    agreeChange(e) {
      if (this.radio == 2) {
        this.s_time = true;
      } else {
        this.s_time = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  },
  created() {
    this.$Http_Post('/querypaper/querypapercondition', { }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.querypapercondition = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data;
      }
    })

    this.$Http_Post('/User/GetUserType', { DeptID: '', DeptName: '', }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetUserTypelist = res.Data
      }
    })

    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',DeptName: '',}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data
      }
    })
    .catch((err) => {
      this.$message({ type: 'error', message: err.message })
    })
    this.Back_num = this.$route.query.param
    if (this.Back_num) {
      this.$Http_Post('ScaleIssue/AddScale', item).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    }
  },
}
</script>
<style>
.abouts {border: 1px solid #e7e7e7;min-height: 95%;padding: 16px;position: relative;background-color: #fff;}
.about_h2 {font-size: 16px;position: relative;}
.about_h2 span {position: absolute;top: 0px;left: 8px;}
.about_h2_t {font-size: 16px;position: relative;margin-bottom: 10px;}
.about_h2_t span {position: absolute;top: 0px;left: 8px;color: rgba(61, 61, 61, 1);}
.about_h2_t i {height: 20px;width: 3px;background-color: rgba(42, 143, 232, 1);display: inline-block;}
.about_h2 i {height: 20px;width: 3px;background-color: rgba(42, 143, 232, 1);display: inline-block;}
.kjks .el-form .el-input {width: 218px !important;}
.kjks form {margin-top: 5px;}
.kjks  .el-tabs__content{padding-bottom: 40px;}
.kjks .el-form-item__content {position: relative;margin-bottom: 0px;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover {border-color: #409eff;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.avatar-uploader {position: absolute;top: 0px;left: 90px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
.scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
.scale ul,.scale0 ul {width: 200px;}
.scale > ul,.scale0 > ul {padding: 5px 12px;width: 298px;background-color: rgba(235, 235, 235, 1);border-radius: 2px;margin-top: -20px;margin-left: 90px;}
.kjks .el-form-item__label {text-align: left;}
.scale > ul li,.scale0 > ul li {background-color: #fff;height: 40px;line-height: 40px;text-align: left;margin-top: 8px;margin-bottom: 8px;position: relative;text-indent: 10px;position: relative;}
.scale > ul li i,.scale0 > ul li i {float: right;margin-right: 14px;margin-top: 14px;position: absolute;right: 0px;top: 0px;}
.scale > ul li span,.scale0 > ul li span {width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inherit;}
.set_time > span {font-size: 14px;color: #606266;margin-left: 16px;padding-top: 14px;display: inline-block;}
.set_time .block {margin-top: -28px;margin-left: 100px;}
.set_time .el-radio {float: left;margin-top: 20px;}
.se_time {position: relative;}
.el-radio-group {margin-left: 80px;margin-top: 0px;}
.time_picker {position: absolute;top: 44px;left: 172px;}
.scale_list > ul {margin-left: 20px;margin-top: 200px;position: relative;}
.scale_list > ul > li {height: 40px;width: 140px;line-height: 40px;text-align: left;}
.scale_list > ul > li ul {position: absolute;left: 200px;}
.scale_right h2 {font-size: 18px;margin-left: 20px;margin-top: 60px;display: inline-block;}
.scale_right_div span {color: rgba(0, 136, 255, 1);margin-left: 10px;}
.scale_right_div i {font-style: normal;}
.scale_right_div .scale_right_input {margin-left: 20px;margin-top: 40px;width: 180px !important;padding-right: 20px;}
.scale .scale_list {margin-top: 50px;}
.scale .el-tabs--left .el-tabs__item.is-left {text-align: left !important;}
.abouts .cvde .el-checkbox-group {width: 300px;margin-top: 0px;height: 40px;}
.scale0 .el-tree {margin-left: 16px;margin-top: 40px;}
.avatar-uploader-icon {background-color: rgb(239 239 239);}
.primarys {height: 40px;margin-bottom: 80px;margin-left: 180px;}
.el-drawer__open .el-drawer.rtl {width: 40% !important;}
.el-tabs--left,.el-tabs--right {overflow: hidden;margin-left: 10px;}
.kjks .confirm {width: 100%;height: 1px;border-top: 1px solid #e1e1e1;margin-top: 30px;}
.abouts .scale_right .el-checkbox {margin-top: 20px;}
.kjks .el-range-editor .el-input__inner {width: 350px !important;}
.kjks .el-textarea {width: 50%;}
.kjks .el-textarea .el-input__count {bottom: -9px;background-color: transparent;}
.cctp {position: absolute;top: 50px;left: 330px;color: rgba(158, 158, 158, 1);}
.kjks .el-textarea__inner{height: 120px;}
</style>
